"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = WizardStep;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _GenericStore = require("../store/GenericStore");

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid/Grid"));

var _Component = _interopRequireDefault(require("../../render/Component"));

var _reactI18next = require("react-i18next");

var _Context = _interopRequireDefault(require("../../Context"));

var _Fab = _interopRequireDefault(require("@material-ui/core/Fab"));

var _styles = require("@material-ui/core/styles");

var _ConfirmationBox = _interopRequireDefault(require("../inputs/ConfirmationBox"));

var _CheckBoxOutlineBlank = _interopRequireDefault(require("@material-ui/icons/CheckBoxOutlineBlank"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    button: {
      width: '90%',
      height: 'auto',
      textTransform: 'initial',
      fontWeight: '400'
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    },
    body: {
      padding: '20px'
    },
    bottom: {
      width: '100%',
      textAlign: 'center',
      marginTop: '20px',
      marginBottom: '20px',
      position: 'absolute',
      bottom: '0px'
    }
  };
});

function WizardStep(props) {
  var block = props.block,
      parentPath = props.parentPath;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var _useContext = (0, _react.useContext)(_Context["default"]),
      onNext = _useContext.onNext;

  var classes = useStyles();

  var _useDataStore = (0, _GenericStore.useDataStore)(parentPath + '/value', false),
      _useDataStore2 = (0, _slicedToArray2["default"])(_useDataStore, 2),
      checked = _useDataStore2[0],
      setChecked = _useDataStore2[1];

  var handleChange = function handleChange(event) {
    setChecked(true);
    onNext.onNext();
  };

  (0, _react.useEffect)(function () {});
  var formComponents = block.content;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.body
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    spacing: block.styling.spacing
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h6"
  }, t(block.label))), formComponents.map(function (component) {
    return /*#__PURE__*/_react["default"].createElement(_Component["default"], {
      block: component,
      parentPath: parentPath + block.path,
      store: _GenericStore.dataStore,
      key: parentPath + component.path,
      isPreconditionData: block === null || block === void 0 ? void 0 : block.isPreconditionData
    });
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.bottom
  }, /*#__PURE__*/_react["default"].createElement(_Fab["default"], {
    variant: "extended",
    color: "primary",
    className: classes.button,
    onclock: handleChange
  }, /*#__PURE__*/_react["default"].createElement(_CheckBoxOutlineBlank["default"], null), t(block.confirmationText)))));
}